module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.833 22l-8-6 8-6v12zm-13 0V10h3v12h-3z\"></path></svg>"